export class SerialListElement {
  public SerialNumber: string;
  public NetworkAvailable = false;

  constructor(serial: string) {
    this.SerialNumber = serial;
  }
}
